import { smartSort } from './arrays'
import { safeConfigurationOptions } from './general'

export function getSafePropertyData(property) {
  return {
    ...property,
    unit_types: property.unit_types
      // Filter out  unit types that have empty levels
      .filter((u) => u.unit_type_levels.length > 0)
      // Filter out unit types , which levels are having empty designs or not having models
      .filter((u) =>
        u.unit_type_levels.every(
          (l) => l.design_layouts.length > 0 && l.design_layouts.some((d) => d.models.length > 0),
        ),
      )
      // Filter out unit types, which packages are empty
      .filter((u) => u.packages?.length > 0)
      // Filter out unit types, which packages,  unit plans are empty
      .filter((u) => u.packages.filter((p) => p.unit_plans.length > 0))
      // Sort unit types by number of bedrooms in ascending order
      .sort(smartSort('number_of_bedrooms'), 'asc')
  }
}

export function getDesignLayoutForUnitPlan(plan) {
  if(!plan) {
    return 
  }
  return plan.design_layout || plan.unit_type_level?.design_layouts.filter((d) => d.main_vendor.id === plan.vendor.id).find((d) => d.models.length > 0)
}